import React, { Component } from 'react';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';


class ComparisonTableRow extends Component {
    displayName = ComparisonTableRow.name

    formatCurrency(value) {
        var v = Math.floor(value);
        return Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(v);
    }

    render() {
        const ph = this.props.personalSummary[this.props.fieldName];
        const spv = this.props.spvSummary[this.props.fieldName];

        var phClass = '';
        var spvClass = '';

        var delta = '';

        if (this.props.highlight && ph != spv) {
            if (this.props.highlightLower) {
                phClass = ph < spv ? 'text-success' : 'text-danger';
                spvClass = spv < ph ? 'text-success' : 'text-danger';
                delta = ph - spv;
            } else {
                phClass = ph > spv ? 'text-success' : 'text-danger';
                spvClass = spv > ph ? 'text-success' : 'text-danger';
                delta = spv - ph;
            }
        }


        return (
            <React.Fragment>
                {
                    ph != 0 && spv != 0 &&
                    <tr className='text-right'>
                        <th className='text-left'>{this.props.title}</th>
                        <td className={spvClass}>{this.formatCurrency(spv)}</td>
                        <td className={phClass}>{this.formatCurrency(ph)}</td>
                        <td className={spvClass}>{delta ? this.formatCurrency(delta) : ''}</td>
                    </tr>
                }
            </React.Fragment>
        );
    }
}

class ComparisonTable extends Component {
    displayName = ComparisonTable.name

    render() {
        return (
            <Table className='comparison'>
                <thead>
                    <tr className='text-right'>
                        <th></th>
                        <th className='spv'>Company held</th>
                        <th className='personal'>Personally held</th>
                        <th>Difference</th>
                    </tr>
                </thead>
                <tbody>
                    <ComparisonTableRow title="Profit" fieldName="grossProfit" spvSummary={this.props.spv.summary} personalSummary={this.props.personal.summary} />
                    <ComparisonTableRow title="Taxes" fieldName="taxTotal" spvSummary={this.props.spv.summary} personalSummary={this.props.personal.summary} highlight={true} highlightLower={true} />
                    <ComparisonTableRow title="Profit retained after tax" fieldName="netProfitRetained" spvSummary={this.props.spv.summary} personalSummary={this.props.personal.summary} highlight={true} />
                    <ComparisonTableRow title="Profit after tax" fieldName="netProfitReturned" spvSummary={this.props.spv.summary} personalSummary={this.props.personal.summary} highlight={true} />
                </tbody>
            </Table>
        );
    }

}



const mapStateToProps = state => {
    return state.tax;
};


export default connect(mapStateToProps)(ComparisonTable);


// WEBPACK FOOTER //
// ./src/Features/TaxCalculator/Components/ComparisonTable.jsx